import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import * as _ from 'lodash';
import { BehaviorSubject, TimeoutError } from 'rxjs';
import { Observable } from 'rxjs';
import { MSG_TYPE } from '../enum/message.enum';
import { MessageMeta } from '../interface/message-meta.interface';

@Injectable({
  providedIn: 'root'
})

// @ts-ignore
export class MessagesService {
  private subject = new BehaviorSubject<any>('');

  /**
   * 发送全局广播
   */
  sendMessage(msg: MessageMeta | any) {
    this.subject.next(msg);
  }

  /**
   * 接收全局广播
   */
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
